import Button from 'antd/lib/button'

import 'antd/lib/button/style'

export * from 'antd/lib/button'

export default Button
